export enum AdminView {
  Cities = "Cities",
  Surveys = "Surveys",
  Users = "Users",
  Accounts = "Accounts",
  Integrations = "Integrations",
  Tools = "Tools",
}
